import { useReservationExpirationCountdown } from '~/utils/hooks/useReservationExpirationCountdown'

import ReservationExpired from '~/components/Reservation/ReservationExpired/ReservationExpired'

import CheckoutLayoutNew from '.'
import { CheckoutHeaderLogo, CheckoutHeaderView } from './CheckoutHeader/CheckoutHeaderView'

export function ReservationExpiredFallback({ children }: { children: JSX.Element }) {
  const countdown = useReservationExpirationCountdown()

  if (countdown !== null && countdown <= 0) {
    return (
      <CheckoutLayoutNew
        header={
          <CheckoutHeaderView>
            <CheckoutHeaderLogo />
          </CheckoutHeaderView>
        }
        contentStyle={{ mobileBackground: '#fff' }}>
        <ReservationExpired />
      </CheckoutLayoutNew>
    )
  }

  return children
}
